<ion-content color="grayDemon">
  <ng-container *ngIf="slide">
    <swiper-container #swiperOverlay class="swiper-container">
      <ng-container *ngFor="let item of otherParameters; let i = index">
        <swiper-slide>
          <first-overlays
            [otherParameters]="item"
            (agreed)="slideDismiss(i)"
            [attr.data-test]="'Automation.btn-overlay-entendido' | translate"
          ></first-overlays>
        </swiper-slide>
      </ng-container>
    </swiper-container>
  </ng-container>

  <ng-container *ngIf="!slide">
    <first-overlays
      [otherParameters]="otherParameters"
      (agreed)="onDismiss($event)"
      [attr.data-test]="'Automation.btn-overlay-entendido' | translate"
    ></first-overlays>
  </ng-container>
</ion-content>
